'use strict';

import { Widgets } from './registry';

const FIRST_DAY_MONDAY = 1;

Widgets.register('date', ($element, data) => {
    $element.datepicker({
        dateFormat: data.dateFormat,
        firstDay: FIRST_DAY_MONDAY,
    });
}, {
    isInitialized: ($element) => $element.hasClass('hasDatepicker'),
});
